import React, { useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components'
import { RCWidth, base, countries, deepClone, generateCircleDot, generateCircleDotCR, getCountryName, getRootDomain, getRootDomain_adv } from '../utils'
import ReportProblemIcon from '@mui/icons-material/ReportProblem'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { useSelector, useDispatch } from 'react-redux'
import Loading from './Loading'
import { updateProjects } from '../Redux/projectsSlice'
import { doc, updateDoc } from 'firebase/firestore'
import { auth, db } from '../firebase'
import { redNex } from '../Redux/nexSlice'
import BubbleChart from './BubbleChart'
import MarketSharePieChart from './MarketSharePieChart'
import PageAuthorityVsRankScatterPlot from './PageAuthorityVsRankScatterPlot'
import BubbleChartIcon from '@mui/icons-material/BubbleChart';
import ScatterPlotIcon from '@mui/icons-material/ScatterPlot';
import PieChartIcon from '@mui/icons-material/PieChart';
import LaunchIcon from '@mui/icons-material/Launch';
import ToggleOffIcon from '@mui/icons-material/ToggleOff';
import ToggleOnIcon from '@mui/icons-material/ToggleOn';

function CompetitionResearch({ listn, nexListn, _nex }) {
    const [url, setUrl] = useState('example.com')
    const [keyword, setKeyword] = useState('')
    const [location, setLocation] = useState('')
    const [data, setData] = useState([])
    const [selectedCompetitors, setSelectedCompetitors] = useState([])
    const [projectName, setProjectName] = useState('')
    const [projects, setProjects] = useState([]);

    const [isEmptyName, setIsEmptyName] = useState(false);
    const [inProject, setInProject] = useState([]);
    const [isCreated, setIsCreated] = useState(false);
    const [isSameName, setIsSameName] = useState(false);

    const [isLoading, setIsLoading] = useState(false)

    const [noInput1, setNoInput1] = useState(false)
    const [noInput2, setNoInput2] = useState(false)
    const [noInput3, setNoInput3] = useState(false)

    const [pagesView, setPagesView] = useState(false)


    const gProjects = useSelector(state=> state.projects.projects)
    const user = useSelector(state=> state.user.user)
    const nx = useSelector(state=> state.nex.nex)


    useEffect(()=> {
      if(gProjects) setProjects(gProjects)
    }, [])


    const dispatch = useDispatch()


    const getData = async () => {
        if(keyword !== '' && url !== '' && location !== '') {
          setNoInput1(false)
          setNoInput2(false)
          setNoInput3(false)

          const updateAnalytics = async () => {
            const tool = window.location.pathname.split('/').pop();
            let tools = deepClone(user.analytics.toolsUsage);
        
            if (isNaN(tools[tool]) || tools[tool] == 'NaN') {
                tools[tool] = 1;
            } else {
                tools[tool] = Number(tools[tool]) + 1;
            }
        
            await updateDoc(doc(db, 'users', user.id), { analytics: { toolsUsage: tools } });
        };
          
          setIsLoading(true)
            fetch(`${base}/res`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                type: 'cr',
                url: url,
                keyword: keyword,
                location: location,
                userId: user.id
              })
            }).then(res=> res.json()).then(data=> {
                const sortedData = [...data].sort((a, b) => {
                    if (a.rank === 'na') return 1;
                    if (b.rank === 'na') return -1;
                    return a.rank - b.rank;
                })
              setData(sortedData)
              setIsLoading(false)
              dispatch(redNex(nx))
              // nexListn()
              updateAnalytics()
            })
          } else {
            if(keyword.trim() === '') setNoInput1(true)
            if(url.trim() === '') setNoInput2(true)
            if(location.trim() === '') setNoInput3(true)
          }
    }

    const createCompProject = async () => {
      if(selectedCompetitors.length !== 0 && projectName !== '') {
        let sameName = gProjects.find(x=> x.name.toLowerCase() === projectName.toLowerCase() && x.type === 'competition')

        if(sameName) {
          setIsSameName(true)
          return
        }

        let updatedProjects = [...projects, { name: projectName.trim(), type: 'competition', urls: selectedCompetitors, data: [], lastUpdated: new Date().toUTCString(), n: projects?.length + 1 }]

        dispatch(updateProjects(updatedProjects))
        listn()
        setInProject(prev=> [...prev, ...selectedCompetitors])
        setIsEmptyName(false)
        setProjectName('')
        setSelectedCompetitors([])
        setIsCreated(true)
      } else {
        setIsEmptyName(true)
      }
    }



    const handleCompetitorSelect = (competitorUrl) => {
      if (selectedCompetitors.includes(competitorUrl)) {
          setSelectedCompetitors(selectedCompetitors.filter(url => url !== competitorUrl))
      } else {
          setSelectedCompetitors([...selectedCompetitors, competitorUrl])
      }
  }

  useEffect(()=> {
    if(selectedCompetitors.length === 0) {
      setIsEmptyName(false)
    }
  }, [selectedCompetitors])


  useEffect(()=> {
    if(isCreated) {
      const clear = setTimeout(()=> {
        setIsCreated(false)
      }, 5000)

      return ()=> clearTimeout(clear)
    }
  }, [isCreated])


  useEffect(()=> {
    if(isSameName) {
      const clear = setTimeout(()=> {
        setIsSameName(false)
      }, 6000)

      return ()=> clearTimeout(clear)
    }
  }, [isSameName])



return (
    <CompetitionResearchContainer>
        <CompetitionResearchInputContainer>
            <div>
            <h2>Competition Research</h2>
            {/* {selectedCompetitors.length !== 0 && <div style={{position: 'relative'}}>
              <input type='text' style={{visibility: selectedCompetitors.length <= 6? 'visible': 'hidden', border: isEmptyName? '1px solid red': ''}} required value={projectName} onChange={e=> setProjectName(e.target.value)} placeholder='Project name...'/>
              <button onClick={selectedCompetitors.length <= 5? createCompProject: ()=> {}} style={{backgroundColor: selectedCompetitors.length <= 5? '': 'lightgray'}}>Create Project with {selectedCompetitors.length === 1? 'this competitor': 'these competitors'}</button>
              {selectedCompetitors.length > 5 && <p style={{color: 'red', position: 'absolute', top: '30px', width: '420px'}}>You can only select up to 5 urls, please deselect some urls before adding more.</p>}
              {isSameName && <p style={{color: 'red', position: 'absolute', top: '30px', width: '420px'}}>You already have a competition project with the same name!</p>}
            </div>} */}
            {selectedCompetitors.length !== 0 && <h3 style={{color: '#8884d8'}} className='fade-effect'>The Competition Project is in development and will be available soon</h3>}
            </div>
            <CompetitionResearchInnerInputContainer>
                {/* <div style={{position: 'relative', marginBottom: '20px', width: '300px'}}><label style={{position: 'absolute', transform: 'translateY(-70%)', left: '2px', top: '20%', fontSize: 'small'}}>Your Website or Webpage</label><input type='url' placeholder='example.com' style={{marginLeft: '20px', borderColor: noInput1? 'red': ''}} value={url} onChange={e=> setUrl(e.target.value)}/></div> */}
                <div style={{position: 'relative', marginBottom: '20px', width: '400px'}}><label style={{position: 'absolute', transform: 'translateY(-70%)', left: '2px', top: '20%', fontSize: 'small'}}>Keyword to Check Competitors For</label><input type='text' placeholder='ice cream recipes' style={{marginLeft: '20px', borderColor: noInput2? 'red': '', color: '#065eb7'}} value={keyword} onChange={e=> setKeyword(e.target.value)}/></div>
                <select name="country" value={location} onChange={e=> setLocation(e.target.value)} className='select-country' style={noInput3? {borderColor: 'red'}: {}}>
                    {countries()}
                </select>
                {nx !== 0 && <button onClick={()=> !isLoading? getData() : ()=> {}} style={isLoading ? {backgroundColor: 'lightgray', color: 'gray', cursor: 'not-allowed'}: {}}>{!isLoading ?'Get Data': 'Getting Data ...'}</button>}
          {nx == 0 && <button style={{backgroundColor: 'lightgray', color: 'red', cursor: 'not-allowed', width: '260px'}}>Insufficient Nexilum units!</button>}
            </CompetitionResearchInnerInputContainer>
        </CompetitionResearchInputContainer>

        <DataContainer style={{position: 'relative'}}>
        {data?.length !==0 && !isLoading && <CompetitorsContainerZero>
          <Competitor>
          <div className='c_url_t' style={{fontWeight: 'bold'}}>Organic Competitors
            <div>
              <p style={{color: pagesView ? 'var(--res-color)' : 'lightgray'}} onClick={() => setPagesView(prev => !prev)}>Pages</p>
              {!pagesView && <ToggleOnIcon onClick={() => setPagesView(prev => !prev)} style={{color: 'var(--res-color)'}}/>}
              {pagesView && <ToggleOffIcon onClick={() => setPagesView(prev => !prev)} style={{color: 'var(--res-color)'}}/>}
              <p style={{color: pagesView ? 'lightgray' : 'var(--res-color)'}} onClick={() => setPagesView(prev => !prev)}>Domains</p>
            </div>
        </div>
            <p className='c_rank' style={{fontWeight: 'bold'}}>Competitor SERP Position for the Keyword</p>
            <p className='c_et' style={{fontWeight: 'bold'}}>Estimated Traffic</p>
          </Competitor>
          {data.map((c, i)=> {
            if(c.rank == 'na') return

            return (
              <Competitor key={i}>
                <p className='c_url' onClick={()=> window.open(url, '_blank')}>{pagesView? c.url: getRootDomain_adv(c.url)} <LaunchIcon style={{fontSize: 'small'}}/></p>
                <p className='c_rank' style={{marginLeft: '20px'}}>{c.rank}</p>
                <p className='c_et'>{c.et}</p>
              </Competitor>
            )
          })}
        </CompetitorsContainerZero>}
        
        {data?.length !== 0 && !isLoading && <ChartContainer>
          <div style={{width: '60%'}}><BubbleChart data={data} /></div>
          <div style={{width: '35%', marginRight: '30px'}} className='info'>
          <p><strong><BubbleChartIcon /> Bubble Size</strong><br/> Represents the number of backlinks (Larger bubbles = More backlinks)</p>
          <p><strong><BubbleChartIcon /> Bubble Color</strong><br/> Randomly assigned color for visual distinction (Different colors = Different domains = Different competitors)</p>
          <p><strong><BubbleChartIcon /> Bubble Position</strong><br/> Further to the right means higher domain authority. Higher on the chart means higher rank on the SERP</p>
          </div>
        </ChartContainer>}

        {data?.length !== 0 && !isLoading && <PieChartContainer>
        <div style={{width: '60%'}}><PageAuthorityVsRankScatterPlot data={data}/></div>
        <div style={{ width: '35%', marginRight: '30px' }} className='info'>
          <p><strong><ScatterPlotIcon /> Scatter Plot Points</strong> <br/> Each point represents a page with its Page Authority and Rank. Higher Page Authority values are shown along the x-axis, while Rank values (where a lower number indicates a higher rank) are shown along the y-axis.</p>
          <p>Hover over each point to view detailed information including Page Authority, Rank, and URL. Tooltips help in understanding individual data points better.</p>
          <p><strong><ScatterPlotIcon /> Axes</strong><br/> The x-axis represents Page Authority, and the y-axis represents Rank. Use this to identify pages with similar Page Authority to yours. If you find such pages, it indicates that your site has a chance to rank for the keyword</p>
        </div>
        </PieChartContainer>}

        {data?.length !== 0 && !isLoading && <PieChartContainer>
        <div style={{width: '60%'}}><MarketSharePieChart data={data} keyword={keyword} location={getCountryName(location)} /></div>
        <div style={{ width: '35%', marginRight: '30px' }} className='info'>
        <p><strong><PieChartIcon /> Pie Slice Size</strong><br/> Represents the proportion of traffic for each domain (Larger slices = More traffic)</p>
        <p><strong><PieChartIcon /> Slice Color</strong><br/> Randomly assigned vibrant color for visual distinction (Different colors = Different domains = Different competitors)</p>
        <p><strong><PieChartIcon /> Legend</strong><br/> Displays each page’s domian with its corresponding color. Use the legend to match colors with slices.</p>
      </div>
        </PieChartContainer>}

        {data?.length !== 0 && !isLoading && <h2 style={{color: 'white', fontSize: '25px', fontFamily: 'Quicksand', marginBlock: '20px', marginLeft: '20px', fontWeight: '400'}}>Search Engine Results Page (SERP) for <span style={{fontFamily: 'Quicksand', color: 'dodgerblue'}}>{keyword}</span> in <span style={{fontFamily: 'Quicksand', color: 'dodgerblue'}}>{getCountryName(location)}</span></h2>}
        {data?.length !== 0 && !isLoading && <CompetitionResContainer style={{position: 'sticky', top: '0', marginBottom: '0px'}}>
        <CompetitorContainer>
                        {/* <p style={{width: '30x', marginRight: '50px'}}>Select</p> */}
                        <p style={{width: '20px', fontSize: 'medium'}}>Rank</p>
                        <div style={{display: 'flex', flexDirection: 'row', alignItems: 'flex-start', gap: '25px'}}><div style={{display: 'flex', flexDirection: 'row'}}><span style={{marginLeft: '7px', fontFamily: 'Quicksand'}}>Website</span></div>{selectedCompetitors.length !== 0 && <span style={{color: selectedCompetitors.length <= 5?'#8884d8': 'red', fontSize: 'small'}}>{selectedCompetitors?.length} selected urls</span>}</div>
                        <p style={{marginLeft: '20px', width: '100px', fontSize: 'medium'}}>Page Authority</p>
                        <p style={{marginLeft: '20px', width: '100px', fontSize: 'medium'}}>Domain Authority</p>
                        <p style={{marginLeft: '20px', width: '120px', fontSize: 'medium'}}>Est. Traffic</p>
                        <p style={{marginLeft: '20px', width: '120px', fontSize: 'medium'}}>Dofollow Links</p>
                        <p style={{marginLeft: '20px', width: '100px', fontSize: 'medium'}}>Domains</p>
        </CompetitorContainer>
        </CompetitionResContainer>}
        {data?.length !== 0 && !isLoading && <CompetitionResContainer style={{marginTop: '0px'}}>
           
            <div style={{overflowX: 'hidden', overflowY: 'hidden', maxHeight: 'fit-content'}}>
            {data?.map((c, i)=> {
                if(c.rank === 'na') {return}
                return (
                    <>
                    {(i === 0 && Number(data[i].rank) !== 1) && <div style={{display: 'flex', flexDirection: 'row', padding: '10px', margin: '5px 20px', color: 'orange', alignItems: 'center'}}><ReportProblemIcon style={{marginRight: '10px'}} /> We couldn't get the first {Number(data[i].rank) - 1} websites!</div>}
                    <CompetitorContainer selected={selectedCompetitors.includes(c.url)}>
                      {/* <div style={{width: '20px', height: '20px', margin: '0 80px 0px 0'}}><SelectBox selected={selectedCompetitors.includes(c.url)} onClick={() => handleCompetitorSelect(c.url)}/></div> */}
                        <p style={{width: '20px', fontSize: 'medium'}}>{c.rank}</p>
                        <div><div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}><img src={c.img} onClick={()=> window.open(c.url, '_blank')} style={{cursor: 'pointer'}}/><span style={{fontWeight: 'normal', marginLeft: '7px', color: 'dodgerblue', cursor: 'pointer', fontFamily: 'Quicksand'}} onClick={()=> window.open(c.url, '_blank')}>{c.title}</span></div><span style={{color: '#019701', fontSize: 'small', cursor: 'pointer', fontFamily: 'Quicksand'}} onClick={()=> window.open(c.url, '_blank')}>{c.url}</span></div>
                        {/* <p style={{marginLeft: '20px', width: '100px', fontSize: 'medium', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>{generateCircleDotCR(10, c.pa)}{c.pa}</p>
                        <p style={{marginLeft: '20px', width: '100px', fontSize: 'medium', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>{generateCircleDotCR(10, c.da)}{c.da}</p> */}
                        <p style={{marginLeft: '20px', width: '100px', fontSize: 'medium', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>{c.pa}</p>
                        <p style={{marginLeft: '20px', width: '100px', fontSize: 'medium', display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '10px'}}>{c.da}</p>
                        <p style={{marginLeft: '20px', width: '120px', fontSize: 'medium'}}>{c.et}</p>
                        <p style={{marginLeft: '20px', width: '120px', fontSize: 'medium'}}>{c.dofollow}</p>
                        <p style={{marginLeft: '20px', width: '100px', fontSize: 'medium'}}>{c.domains}</p>
                    </CompetitorContainer>
                    </>
                )
            })}
            </div>
        </CompetitionResContainer>}
        </DataContainer>
        {isLoading && <Loading />}
        {isCreated && <SuccessfulOperation><CheckCircleIcon /> Project Created Successfully</SuccessfulOperation>}

        {data.length === 0 && !isLoading && <Intro>

          <h3>Tool Overview</h3>
          <br />
          <p>
            The Competition Research Tool helps you analyze SEO competitors by entering a keyword and location. 
            It provides insights into how your competitors rank for specific keywords and their overall SEO strategy.
          </p>
          <br /><br />
          
          <h3>Instructions</h3>
          <br />
          <p>1. Enter a keyword in the search bar</p>
          <p>2. Select your target location</p>
          <p>3. Click "Get Data" to view SERP and SEO competitor data</p>
          <br /><br />
          
          <h3>Tips</h3>
          <br />
          <p>Review competitors' rankings and page authorities to identify opportunities for improving your own SEO performance</p>

        </Intro>}
    </CompetitionResearchContainer>
  )
}

export default CompetitionResearch


const CompetitionResearchContainer = styled.div`
    display: flex;
    flex-direction: column;
    width: ${RCWidth};
    /* background-color: var(--ml-color);
    z-index: 10000; */
`

const FadeEffect = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`


const CompetitionResearchInputContainer = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 3px;
  box-shadow: 2px 2px 16px -8px rgb(239, 239, 239);
  background-color: white;
  margin-inline: 20px;
  padding: 20px;
  margin-top: 25px;
  z-index: 2;


  > div {
    display: flex;
  }

  > div > h2 {
    font-weight: 100;
    margin-bottom: 20px;
  }

  > div > .fade-effect {
    margin-left: auto;
    font-weight: 300;

    opacity: 0;
    animation: ${FadeEffect} 0.3s ease-in-out forwards;
  }

  > div > div {
    display: flex;
    margin-left: auto;
    gap: 20px;
  }

  > div > div > button {
    background-color: #8884d8;
    color: white;
    cursor: pointer;
    border: none;
    border-radius: 2px;
    padding: 5px 8px;
    height: fit-content;
  }

  > div > div> button:hover {
    background-color: transparent;
    color: #8884d8;
  }

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: #065eb7;
    font-family: 'Quicksand';
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
    font-family: 'Quicksand';
  }

  > div > .select-country {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    margin-left: 20px;
    color: #065eb7;
  }

  > div > button {
    border: none;
    border-radius: 2px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    padding: 5px;
    margin-left: 60px;
    cursor: pointer;
    background-color: dodgerblue;
    color: white;
  }

  > div > button:hover {
    color: dodgerblue;
    background-color: rgb(239, 239, 239);
  }

  > div > div > input {
      border: 1px solid lightgray;
      outline: none;
      border-radius: 3px;
      height: fit-content;
      padding: 4px;
  }
`


const CompetitionResearchInnerInputContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin-top: 20px;
  justify-content: flex-start !important;
  padding-left: 0px !important;
  

  > div {
    display: flex;
    justify-content: flex-start !important;
    padding-left: 0px !important;
    margin-left: 0px !important;
  }
  

  > div > input {
    outline: none;
    border-radius: 2px;
    width: 200px;
    height: 30px;
    border: 1px solid rgba(235, 235, 235);
    box-shadow: 1px 10px 30px -7px rgba(235, 235, 235);
    padding-inline: 5px;
    margin-block: 10px;
    color: dodgerblue;
    padding-left: 100px;
    font-size: medium;
    margin-left: 0px !important;
  }

  > div > input::placeholder {
    color: rgba(180, 180, 180);
  }
`


const DataContainer = styled.div`
  max-height: 460px; 
  overflow-y: auto;
  border-radius: 2px;
  /* margin: 20px; */
  margin-top: 16px;

  opacity: 0;
  animation: ${FadeEffect} 0.3s ease-in-out forwards;
`


const CompetitionResContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 20px;
  background-color: white;
  z-index: 2;
  margin-bottom: 70px;
  overflow-x: hidden;
  overflow-y: hidden;
  padding-bottom: 10px;
`


const CompetitorContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding: 10px;
    margin-block: 5px;
    border-bottom: 1px solid rgb(230, 230, 230);
    background-color: ${({ selected }) => selected ? 'rgb(223, 239, 255)' : ''};
    align-items: center;

    > p {
      font-family: 'Quicksand';
    }


    > div {
        display: flex;
        flex-direction: column;
        width: 400px;
        margin-left: 30px;
    }
`


const SelectBox = styled.div`
  width: 20px;
  height: 20px;
  border: 1px solid #ccc;
  cursor: pointer;
  background-color: ${({ selected }) => selected ? 'dodgerblue' : 'white'};
`


const SuccessfulOperation = styled.div`
  position: fixed;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 15px;
  background-color: rgb(46, 222, 152);
  padding-block: 8px;
  z-index: 1000;
  padding-left: 450px;

  opacity: 0;
  animation: ${FadeEffect} 0.5s ease-in-out forwards;
`


const ChartContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding: 5px;
    margin: 20px;
    overflow-x: hidden;
    overflow-y: hidden;
    background-color: transparent !important;
    border-radius: 2px;
    z-index: 2;
    margin-bottom: 30px;
    padding-bottom: 10px;
    height: 500px;
    gap: 10px;
    width: 100%;
   

    > .info {
      display: flex;
      flex-direction: column;
      gap: 10px;
      justify-content: start;
      margin-left: auto;
      /* background-color: rgb(40, 47, 60); */
      background-color: #17163b;
      height: fit-content;
      width: fit-content;
      border-radius: 3px;
      padding-block: 10px;



      > p {
        color: white;
        font-family: 'Quicksand';
        margin-left: 10px;

        > strong {
          font-family: 'Quicksand';
          margin-left: 10px;
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 5px;
        }
      }
    }
`


const PieChartContainer = styled.div`
    display: flex;
    flex-direction: row;
    padding: 5px;
    margin: 20px;
    overflow-x: hidden;
    overflow-y: hidden;
    background-color: transparent !important;
    border-radius: 2px;
    z-index: 2;
    margin-bottom: 30px;
    padding-bottom: 10px;
    height: 400px;
    gap: 10px;
    width: 100%;
   

    > .info {
      display: flex;
      flex-direction: column;
      gap: 10px;
      justify-content: start;
      margin-left: auto;
      /* background-color: rgb(40, 47, 60); */
      background-color: #17163b;
      height: fit-content;
      width: fit-content;
      border-radius: 3px;
      padding-block: 10px;



      > p {
        color: white;
        font-family: 'Quicksand';
        margin-left: 10px;

        > strong {
          font-family: 'Quicksand';
          margin-left: 10px;
          display: flex;
          flex-direction: row;
          align-items: center;
          gap: 5px;
        }
      }
    }
`

const Intro = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px 20px 20px 20px;

  opacity: 0;
  animation: ${FadeEffect} 0.3s ease-in-out forwards;

  > h3 {
    color: white;
    font-family: 'Quicksand';
    font-weight: 500;
  }

  > p {
    color: white;
    font-family: 'Quicksand';
    width: 60%;
  }
`

const CompetitorsContainerZero = styled.div`
  display: flex;
  flex-direction: column;
  padding: 10px;
  gap: 20px;
  background-color: #17163b;
  border-radius: 3px;
  margin: 20px;
  margin-bottom: 160px;
`

const Competitor = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid gray;
  padding-bottom: 7px;

  > p {
    font-family: 'Quicksand';
    color: white;
  }

  > .c_url_t {
    width: 300px;
    display: flex;
    flex-direction: row;
    align-items: center;
    color: white;

    > div {
      display: flex;
      align-items: center;
      gap: 5px;
      margin-left: auto;

      > p {
        font-family: 'Quicksand';
        font-size: small;
        cursor: pointer;
      }

      > .MuiSvgIcon-root {
        font-size: larger;
        cursor: pointer;
      }
    }
  }

  > .c_url {
    width: 300px;
    transition: color 0.3s ease-in-out;
    cursor: pointer;
    word-wrap: break-word;

    &:hover {
      color: var(--res-color);
    }
  }

  > .c_et {
    width: 200px;
  }

  > .c_rank {
    width: 360px;
  }
`